import { TApi } from "@/api/useApi";
import { Auth } from "@aws-amplify/auth";
import Router from "next/router";

export type TUser = {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  role: number;
  token: string;
  avatar?: string;
};

/** Sets response interceptors that run on errors  */
export function setErrorInterceptors(api: TApi, onError?: (statusCode: number) => void) {
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      switch (error?.response?.status) {
        case 401:
          onError?.(401);
          break;

        case 403:
          onError?.(403);
          break;

        case 404:
          onError?.(404);
          break;
      }

      return Promise.reject(error);
    }
  );
}

export const logout = async (redirect = true) => {
  await Auth.signOut();
  if (redirect) {
    Router.push("/signin");
  }
};

export async function getJwt(logoutOnError = false) {
  try {
    const session = await Auth.currentSession();
    const token = session.getAccessToken().getJwtToken();
    return token;
  } catch (e) {
    console.error("Failed to get session:", e);
    if (logoutOnError) {
      await logout();
    }
    return "";
  }
}
